export default "__VITE_ASSET__2d15302f__"